// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1qbew","choiceBoxes":"toolbarselects_choiceBoxes__mIUeo","simpleField":"toolbarselects_simpleField__1AiPp"};